export const getCountry = () => {
  if (location && location.hostname) {
    const allowedCountries = ['br', 'ar', 'ec', 'co', 'pe', 'cl', 'do', 'gt', 'uy', 'sv', 'pa', 'py'];
    const currentCountry = location.hostname
      .toLowerCase()
      .split('.')
      .pop() as string;

    return allowedCountries.includes(currentCountry) ? currentCountry : 'br';
  }

  return 'br';
};

export const getWithDotComByCountry = (c: string) => {
  const countryNotCom = ['cl', 'gt'];

  return countryNotCom.indexOf(c) === -1 ? '.com.' : '.';
};

export const getCountryName = (acronym: string): string => {
  const names = {
    br: 'Brasil',
    ar: 'Argentina',
    ec: 'Equador',
    co: 'Colômbia',
    pe: 'Peru',
    cl: 'Chile',
    do: 'República Dominicana',
    gt: 'Guatemala',
    uy: 'Uruguai',
    cr: 'Costa Rica',
    sv: 'El Salvador',
    pa: 'Panamá',
    py: 'Paraguai',
  };

  return names[acronym as keyof typeof names];
};
